var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Connect = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M6.75 16.5C6.75 17.9497 5.57475 19.125 4.125 19.125C2.67525 19.125 1.5 17.9497 1.5 16.5C1.5 15.0503 2.67525 13.875 4.125 13.875C5.57475 13.875 6.75 15.0503 6.75 16.5ZM6.75 16.5H7.5C8.69347 16.5 9.83807 16.0259 10.682 15.182C11.5259 14.3381 12 13.1935 12 12C12 10.8065 12.4741 9.66193 13.318 8.81802C14.1619 7.97411 15.3065 7.5 16.5 7.5H22.5M18.75 3.75L22.5 7.5M22.5 7.5L18.75 11.25", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
